<template>
  <div class="user-profile-view_upv">
    <object-search-form/>
    <user-profile-display v-if="userId" :userId="userId" class="upv_profile"/>
    <div class="page-container_pcr"><h2 class="upv_h2">Авторские объекты</h2></div>
    <objects-search/>
    <page-footer/>
  </div>
</template>

<script>
import ObjectSearchForm from '@/components/ObjectSearchForm';
import UserProfileDisplay from '@/components/UserProfileDisplay';
import PageFooter from '@/components/PageFooter';
import ObjectsSearch from '@/components/layouts/ObjectsSearch';

export default {

  components: { ObjectSearchForm, UserProfileDisplay, ObjectsSearch, PageFooter },

  computed: {

    userId() {
      return this.$route.params.userId;
    },

  },

};
</script>

<style lang="scss">
.user-profile-view_upv {
  .upv_profile {
    margin-top: 60px;
  }
  .upv_h2 {
    font-weight: 500;
    padding-left: 100px;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserProfileView.vue